// Badge de status das entidades de autorização: rótulo do catálogo i18n (`authz:status.*`, o valor cru como reserva) e
// variante por família (`statusVariant`).
import { Badge } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

import { statusVariant } from './statusVariant';

export interface StatusBadgeProps {
  readonly status: string;
  readonly testId?: string | undefined;
}

export function StatusBadge({ status, testId }: StatusBadgeProps) {
  const { t } = useTranslation('authz');
  return (
    <Badge variant={statusVariant(status)} data-testid={testId}>
      {t(`status.${status}`, { defaultValue: status })}
    </Badge>
  );
}
